import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Icon } from '@chakra-ui/react'
import FiChevronLeft from '@meronex/icons/fi/FiChevronLeft'
import FiChevronRight from '@meronex/icons/fi/FiChevronRight'

export const NAVIGATION_GUIDE = {
  PREV: 'prev',
  NEXT: 'next',
}

const ICON = {
  [NAVIGATION_GUIDE.PREV]: FiChevronLeft,
  [NAVIGATION_GUIDE.NEXT]: FiChevronRight,
}

export const Navigation = ({ guide, ...rest }) => {
  return React.createElement(IconButton, {
    'aria-label': guide,
    icon: <Icon as={ICON[guide]} boxSize='1.25rem' />,
    position: 'absolute',
    variant: 'outline',
    size: 'sm',
    borderRadius: 'full',
    ...rest,
  })
}

Navigation.propTypes = {
  guide: PropTypes.oneOf(Object.values(NAVIGATION_GUIDE)),
}
